module.exports = __webpack_public_path__ + "img/tutorial_redactions_02.95b8f60d.gif";